import axios from "axios";
import { ProjectUrl } from "../env";
import store from "../redux/store";
import Alertify from "./alertify";
import { logout } from "../redux/reducers/authSlice";

// Create an axios instance with the base URL
const api = axios.create({
  baseURL: ProjectUrl,
});

// Request interceptor to add the authorization token
api.interceptors.request.use(
  async (config) => {
    // Retrieve token from localStorage or Redux state
    const token =
      localStorage.getItem("token") || store.getState().auth_store.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Use backticks for template literals
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      store.dispatch(logout());
      // window.location.href = "/admin/login";
      const errorMessage =
        error?.response?.data?.error || "Your session is expired";
      Alertify.error(errorMessage);
    }
    return Promise.reject(error?.response?.data);
  },
);

// Centralized error handling function
export function handleApiError(error, rejectWithValue) {
  console.error(error);
  Alertify.error(error?.message || "An error occurred"); // Pass the entire message
  return rejectWithValue(error);
}

// Helper function to handle API requests
const handleApiRequest = async (
  method,
  path,
  data = {},
  headers = {},
  cancelToken,
) => {
  try {
    const response = await api({
      method,
      url: path,
      data,
      headers: {
        Accept: "application/json",
        "ngrok-skip-browser-warning": "69420",
        ...headers,
      },
      cancelToken,
    });
    return response;
  } catch (error) {
    console.error(`API ${method.toUpperCase()} error:`, error); // Use backticks for template literals
    throw error;
  }
};

// Exported API functions
export const postApi = (path, data, headers, cancelToken) =>
  handleApiRequest("post", path, data, headers, cancelToken);

export const getApi = (path, headers, cancelToken) =>
  handleApiRequest("get", path, {}, headers, cancelToken);

export const patchApi = (path, data, headers) =>
  handleApiRequest("patch", path, data, headers);

export const putApi = (path, data, headers) =>
  handleApiRequest("put", path, data, headers);

export const deleteApi = (path, data = {}, headers, cancelToken) =>
  handleApiRequest("delete", path, data, headers, cancelToken);
